<template>
    <SiteSection sectionId="section-work"
             sectionNo="2"
             label="工作環境與福利"
             title="WORK AS A SPROUTER">
        <Environment></Environment>
        <Welfare></Welfare>         
    </SiteSection> 
</template>

<script>
import SiteSection from "./source/Section.vue";
import Environment from "./sectionWork/Environment.vue"
import Welfare from "./sectionWork/Welfare.vue"

export default {
    name: 'SectionWork',
    components: {
        SiteSection,
        Environment,
        Welfare
    },
}
</script>

<style scoped 
       lang="scss">
    @import "../static/styles/palette.scss";

</style>



// WEBPACK FOOTER //
// SectionWork.vue?22531728